export const languages = [
	{
		id: 0,
		lang: {
			short: "en",
			long: "English",
		},
	},
	{
		id: 1,
		lang: {
			short: "zh",
			long: "中文",
		},
	},
	{
		id: 2,
		lang: {
			short: "ko",
			long: "한국어",
		},
	},
];

export const iconData = {
	en: "translate",
	zh: "翻译",
	ko: "번역",
};
